import React, { useEffect, useState } from "react";
import { getSliders } from "../Service/Api";

const HomeSlider = () => {
  const [dynamicSlide, setDynamicSlider] = useState([]);

  const IMAGE_BASE_URL = "https://webapi.entab.info/api/image";

  useEffect(() => {
    async function getSlider() {
      try {
        const response = await getSliders();

        console.log("API RESPONSE:", response);

        const sliderList = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.data?.data)
          ? response.data.data
          : [];

        console.log("SLIDER LIST:", sliderList);

        setDynamicSlider(sliderList);
      } catch (error) {
        console.error("API isn't responding", error);
      }
    }

    getSlider();
  }, []);

  const slides =
    dynamicSlide.length > 0
      ? dynamicSlide
      : [
          {
            _id: "fallback",
            title: "fallback",
            attachment: "JRPSB/Sliders/076de8fabafa0a5bc6923065cabf0388",
          },
        ];

  return (
    <div
      id="carouselExampleControls"
      className="carousel slide"
      data-bs-ride="carousel"
      data-bs-interval="3000"
    >
      <div className="carousel-inner">
        {slides.map((slide, index) => {
          const imageUrl = `${IMAGE_BASE_URL}/${slide.attachment}`;

          return (
            <div
              key={slide._id || index}
              className={`carousel-item ${index === 0 ? "active" : ""}`}
            >
              <img
                src={imageUrl}
                className="d-block w-100"
                alt={slide.title || "slider-img"}
              />
            </div>
          );
        })}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleControls"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleControls"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default HomeSlider;